<template>
    <v-radio-group
        ref="field"
        :id="id"
        v-bind="$attrs"
        :class="{ 'is-invalid': invalid }"
        :value="value"
        :error="invalid"
        :mandatory="required"
        :error-messages="errorMessages"
        :disabled="disabled"
        @change="update"
        @focus="onfocus"
        @blur="onblur"
    >
        <v-radio
            :label="getName(option)"
            :value="getValue(option)"
            v-for="option in computedOptions"
            v-bind="radioAttrs"
        />

        <template #message="messageProps">
            <slot name="message" :message="messageProps.message" />
        </template>
    </v-radio-group>
</template>

<script>
    import FieldMixin from "@/components/form/FieldMixin.vue"
    import FieldWithOptionsMixin from "@/components/form/FieldWithOptionsMixin"

    export default {
        mixins: [FieldMixin, FieldWithOptionsMixin],
        inheritAttrs: false,
        props: {
            radioAttrs: {
                type: Object,
                default: () => {
                    return {}
                },
            },
        },

        data() {
            return {}
        },

        methods: {
            onfocus(event) {
                if (this.vcform) this.vcform.emitFieldEvent("focus", this, event)
            },

            onblur(event) {
                if (this.vcform) this.vcform.emitFieldEvent("blur", this, event)
            },

            update(value) {
                this.$emit("input", value)
            },
        },
    }
</script>
